module.exports = __webpack_public_path__ + "img/fun.30fc35e5.gif";